<template>
  <router-link size="md" class="ml-3 btn no-wrap" :style="{ backgroundColor: '#FFCA10', color: '#151515' }" :to="to">
    <i class="fa fa-list" />
    View report
  </router-link>
</template>

<script lang="ts">
import { defineComponent, computed, type ComputedRef } from 'vue'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { CUSTOMER_ASSIGNMENTS_OPTIMIZATION_REPORT, STAFF_ASSIGNMENTS_OPTIMIZATION_REPORT } from '@/types/router'

export default defineComponent({
  name: 'ViewReport',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const assignmentRef: ComputedRef<string> = computed(() => assignmentSummaryStore.reference || '')
    const routeName: ComputedRef<string> = computed(() =>
      isStaff.value ? STAFF_ASSIGNMENTS_OPTIMIZATION_REPORT : CUSTOMER_ASSIGNMENTS_OPTIMIZATION_REPORT,
    )
    const to = computed(() => ({
      name: routeName.value,
      params: { id: assignmentRef.value },
    }))

    return {
      to,
    }
  },
})
</script>
